<script setup lang="ts">
import { CitiesList } from '../../types/types.api'
import { getCitiesList } from '../../api/user.route'
import { ButtonMain } from '@caks/uikit/button'
import { IconMountain, IconFountain, IconStar, IconBottle } from '@caks/uikit/icon'
import { useAccountStore } from '../../store/store.account'
const router = useRouter()
import { SkeletonChip } from '@caks/uikit/skeleton'

interface Props {
  desktop?: boolean
}

const props = defineProps<Props>()
const cities = ref<{ id: number; name: string }[] | null>(null)
const emit = defineEmits<{ (emit: 'close'): void }>()

const store = useAccountStore()
const selectId = ref<number | null>(null)

const setCity = () => {
  if (!cities.value) return

  let notClose = false

  cities.value.forEach((item) => {
    if (item.id === selectId.value) {
      store.cityId = item.id
      store.city = item.name
      store.citySelected = true
      if (!props.desktop) {
        notClose = true
        sessionStorage.setItem('redirectedFromCity', 'true')
        router.push('/delivery/point')
      }

      if (!notClose) emit('close')
    }
  })
}

const selectCity = (id: number) => {
  selectId.value = id
}

onMounted(async () => {
  const citiesData: CitiesList = await getCitiesList()
  cities.value = citiesData.data
  selectId.value = store.cityId || citiesData.data[0].id
})
</script>

<template>
  <div class="city-popup" :class="{ 'city-popup--desktop': desktop }">
    <h2>Выбрать город</h2>
    <div class="city-popup__image">
      <img src="/assets/images/mock/city.svg" alt="city-image" />
    </div>
    <div class="city-popup__info">
      <h3>Выберите ваш город</h3>
      <p>Для просмотра доступных позиций выберите город</p>
    </div>
    <div class="city-popup__city" v-if="cities">
      <div
        class="city-popup__city-item"
        :class="{ 'city-popup__city-item--active': item.id === selectId }"
        v-for="item in cities"
        :key="item.id"
        @click="selectCity(item.id)"
      >
        <div class="city-popup__icon">
          <template v-if="item.id === 0">
            <icon-mountain />
          </template>
          <template v-if="item.id === 1">
            <icon-bottle />
          </template>
          <template v-if="item.id === 3">
            <icon-star />
          </template>
          <template v-if="item.id === 4">
            <icon-fountain />
          </template>
        </div>
        <p>{{ item.name }}</p>
        <span></span>
      </div>
    </div>
    <div v-else>
      <div class="city-popup__city--waiting">
        <skeleton-chip v-for="_ in 4" />
      </div>
    </div>

    <button-main @click="setCity" :fullWidth="true"> Выбрать </button-main>
  </div>
</template>

<style scoped lang="scss">
.city-popup {
  width: 457px;

  .ion-page & {
    width: 100%;
  }

  h2 {
    @include h2-1;
    color: #0d0802;
    margin-bottom: 48px;
  }

  &__info {
    margin-bottom: 31px;

    h3 {
      text-align: center;
      @include h2-1;
      color: #0d0802;
      margin-bottom: 6px;
    }

    p {
      text-align: center;
      @include h6-2;
      color: #767676;
    }
  }

  &__city {
    min-height: 192px;
    margin-bottom: 30px;

    &--waiting {
      display: flex;
      flex-direction: column;
      margin-bottom: 30px;
      min-height: 192px;

      &::v-deep {
        span {
          max-width: none;
          height: 54px;
          margin-bottom: 8px;
        }
      }
    }
  }

  &__icon {
    background: rgba(0, 158, 80, 0.1);
    box-shadow: 0px 1px 9.5px -1px rgba(0, 0, 0, 0.04);
    backdrop-filter: blur(10.15px);
    border-radius: 10px;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__city-item {
    padding: 12px;
    background: #ffffff;
    border: 1px solid #f1f1f1;
    backdrop-filter: blur(45.6px);
    border-radius: 12px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 17px;
    cursor: pointer;

    &:last-child {
      margin-bottom: 0;
    }

    p {
      @include h5-6;
      color: #0d0802;
      flex: 1;
    }

    span {
      display: block;
      width: 16px;
      height: 16px;
      border: 1.5px solid #009e50;
      border-radius: 50%;
      position: relative;
    }

    &--active {
      border: 1px solid #009e50;

      span {
        &:before {
          content: '';
          position: absolute;
          width: 8px;
          height: 8px;
          background: #009e50;
          border-radius: 50%;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }
}

.city-popup__image {
  width: 200px;
  height: calc(var(--viewport-height) - 549px);
  margin: 0 auto;
  max-height: 200px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .city-popup--desktop & {
    height: calc(100vh - 500px);
  }
}
</style>
